import React from "react";
import "../../Components/Assests/CSS/policy-terms.css";

export default function TermsOfService() {
    return (
        <div className="legal-page">
    <div className="container">
        <div className="legal-card">

            <h1 className="legal-title">Terms of Service</h1>

            <div className="legal-section">
                <h4>Ownership</h4>
                <p>
                    Nsphere Healthcare is a software product developed
                    and maintained by
                    <strong> COOPERWIND INDIA PRIVATE LIMITED</strong>.
                </p>
            </div>

            <div className="legal-section">
                <h4>Service Usage</h4>
                <p>
                    Users agree to use the platform solely for lawful
                    healthcare management and operational purposes.
                </p>
            </div>

            <div className="legal-section">
                <h4>Communications</h4>
                <p>
                    Users may receive service-related notifications,
                    appointment updates and system communications.
                </p>
            </div>

            <div className="legal-section">
                <h4>Limitation of Liability</h4>
                <p>
                    COOPERWIND INDIA PRIVATE LIMITED shall not be liable
                    for interruptions or delays caused by third-party
                    services or circumstances beyond reasonable control.
                </p>
            </div>

            <div className="legal-section">
                <h4>Contact</h4>
                <p>
                    For support contact:
                    <br />
                    TL-Support@Cooperwind.in
                </p>
            </div>

        </div>
    </div>
</div>
    );
}